<template>
  <RightSideBar
    v-if="isOpen"
    @close="isOpen = false"
    close-button
    button-class="bg-dynamicBackBtn text-white"
    @submit="handleSubmit(onSubmit)"
    width="width:520px"
    :loading="isLoading"
  >
    <template v-slot:title>
      <div class="flex justify-start items-center gap-0">
          <back-button @onClick="isOpen = false" variant="secondary" style="padding:0" />
          <span class="text-darkPurple font-bold text-lg">Leave Request</span>
        </div>
    </template>
    <div class="flex flex-col divide-y divide-romanSilver divide-dashed">
      <div class="flex flex-col justify-start gap-5 pb-4">
        <div class="flex justify-between items-center">
          <p class="text-sm text-darkPurple font-normal mb-0">Employee Details</p>
          <div class="rounded-md p-2 text-sm w-28 text-center"
            :class="{
              'bg-green-100 text-mediumSeaGreen': leaveInfo.approvalStatus === 'approved',
              'bg-red-100 text-flame': leaveInfo.approvalStatus === 'disapproved',
              'bg-yellow-100 text-carrotOrange': leaveInfo.approvalStatus === 'pending'
            }"
          >
            {{
              leaveInfo.approvalStatus === 'approved' ? 'Approved':
              leaveInfo.approvalStatus === 'disapproved' ? 'Disapproved':
              leaveInfo.approvalStatus === 'pending' ? 'Pending' : ''
            }}
          </div>
        </div>
        <div class="w-full flex justify-start items-start gap-4">
          <div>
            <span v-if="employeeInfo.photo" class="flex justify-center items-center w-36 h-44">
              <img :src="employeeInfo.photo" class="w-36 h-44 rounded-md" alt="profile photo" />
            </span>
            <div v-else class="flex justify-center items-center w-36 h-44 rounded-md border">
              <span class="text-blueCrayola text-center font-semibold text-6xl p-2">
                {{ $getInitials(`${employeeInfo.fname} ${employeeInfo.lname}`) }}
              </span>
            </div>
          </div>
          <div class="w-full flex flex-col justify-start items-start gap-1">
            <p class="font-bold text-lg text-darkPurple mb-0">
              {{ employeeInfo.fname}} {{ employeeInfo.lname }}
            </p>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver">Function:</span>
              <span class="w-2/5 font-semibold text-sm text-darkPurple">
                {{employeeInfo.orgFunction &&  employeeInfo.orgFunction.name }}
              </span>
            </div>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver">Designation:</span>
              <span class="w-2/5 font-semibold text-sm text-darkPurple">
                {{ employeeInfo.userDesignation && employeeInfo.userDesignation.name }}
              </span>
            </div>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver">Job Level:</span>
              <span class="w-2/5 font-semibold text-sm text-darkPurple">
                {{ employeeInfo.userLevel && employeeInfo.userLevel.name }}
              </span>
            </div>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver">Office Location:</span>
              <span class="w-2/5 font-semibold text-sm text-darkPurple">
                {{ employeeInfo.employeeOffice && employeeInfo.employeeOffice.name }}
              </span>
            </div>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver ">Manager:</span>
              <span v-if="employeeInfo.userReportingTo" class="w-2/5 font-semibold text-sm text-darkPurple">
                {{ employeeInfo.userReportingTo.fname }} {{ employeeInfo.userReportingTo.lname }}
              </span>
            </div>
            <div class="w-full flex jusity-start items-center gap-2">
              <span class="w-3/5 font-semibold text-sm text-romanSilver">Length of Service:</span>
              <span class="w-2/5 font-semibold text-sm text-darkPurple">
                {{ employeeInfo.lengthOfService }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-start gap-4">
          <div class="w-full flex flex-col justify-start items-start gap-2 pb-1">
            <span class="text-sm text-jet font-normal">Request Date</span>
            <div class="w-full bg-cultured border border-romanSilver rounded-md py-2 px-4">
              <span class="text-romanSilver text-base font-normal">
                {{ $DATEFORMAT(new Date(leaveInfo.createdAt), 'MMMM dd, yyyy') }}
              </span>
            </div>
          </div>
          <div class="w-full flex flex-col justify-start items-start gap-2 pb-1">
            <span class="text-sm text-jet font-normal">Leave Type</span>
            <div class="w-full bg-cultured border border-romanSilver rounded-md py-2 px-4">
              <span class="text-romanSilver text-base font-normal">
                {{ leaveInfo.leaveType }}
              </span>
            </div>
          </div>
          <div class="w-full flex flex-col justify-start items-start gap-2 pb-1">
            <span class="text-sm text-jet font-normal">Details</span>
            <div class="w-full bg-cultured border border-romanSilver rounded-md py-2 px-4">
              <span class="text-romanSilver text-base font-normal">
                {{ leaveInfo.details ? leaveInfo.details: '-' }}
              </span>
            </div>
          </div>
          <div class="w-full flex flex-col justify-start items-start gap-2 pb-1">
            <span class="text-sm text-jet font-normal">Leave Duration</span>
            <div class="w-full flex justify-start gap-1">
              <div class="w-full bg-cultured border border-romanSilver rounded-md py-2 px-4">
                <span class="text-romanSilver text-base font-normal">
                  {{ $DATEFORMAT(new Date(leaveInfo.from), 'MMMM dd, yyyy') }} to
                  {{ $DATEFORMAT(new Date(leaveInfo.to), 'MMMM dd, yyyy') }}
                </span>
              </div>
              <div class="w-4/12 bg-cultured border border-romanSilver rounded-md py-2 px-4">
                <span class="text-romanSilver text-base font-normal">
                  {{ leaveInfo.daysRequested }} Day(s)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(leaveInfo.delegatee).length" class="flex flex-col justify-start items-start gap-2 pt-4">
        <p class="font-normal text-sm text-darkPurple mb-0">Delegatee’s Name</p>
        <div class="flex justify-start items-center gap-2 p-2">
          <div>
            <span v-if="leaveInfo.delegatee.photo" class="flex justify-center items-center w-9 h-9">
              <img :src="leaveInfo.delegatee.photo" class="w-9 h-9 rounded-md" alt="profile photo" />
            </span>
            <div v-else class="flex justify-center items-center w-9 h-9 rounded-md border">
              <span class="text-blueCrayola text-center font-semibold text-lg p-2">
                {{ $getInitials(`${leaveInfo.delegatee.fname} ${leaveInfo.delegatee.lname}`) }}
              </span>
            </div>
          </div>
          <div class="flex flex-col flex-grow justify-center items-start">
            <span class="text-base text-darkPurple font-normal mb-0">
              {{ leaveInfo.delegatee.fname }} {{ leaveInfo.delegatee.lname }}
            </span>
            <div class="flex flex-row justify-start items-center gap-2">
              <span class="text-xs flex font-semibold text-romanSilver uppercase mb-0">
                {{ leaveInfo.delegatee.orgFunction && leaveInfo.delegatee.orgFunction.name }}
              </span>
              <span class="text-xs flex font-semibold text-romanSilver uppercase mb-0">
                {{ leaveInfo.delegatee.userDesignation && `• ${leaveInfo.delegatee.userDesignation.name}` }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-4">
        <div class="flex justify-between items-center cursor-pointer mb-4" @click="isHandoverNoteExpanded = !isHandoverNoteExpanded">
          <p class="font-semibold text-sm text-darkPurple">Handover Note</p>
          <c-icon :icon-name="isHandoverNoteExpanded ? 'chevronDown' : 'chevronRight'" size="xs" class=" text-darkPurple" />
        </div>
        <div v-if="isHandoverNoteExpanded" >
          <div v-if="leaveInfo.handoverNote || leaveInfo.fileUrl" class="divide-y divide-romanSilver divide-dashed">
            <div v-if="leaveInfo.handoverNote" class="pb-2">
              <p class="text-sm text-darkPurple">{{ leaveInfo.handoverNote }}</p>
            </div>
            <div v-if="leaveInfo.fileUrl" class="flex items-start p-4 gap-2 flex-grow cursor-pointer hover:bg-ghostWhite rounded-md transition-colors duration-200" @click="downloadFile(leaveInfo.fileUrl, leaveInfo.fileName, leaveInfo.fileMimeType)">
              <div class="w-9 h-9">
                <c-icon icon-name="pdf" size="xs" class="icon" v-if="getFileExtension(leaveInfo.fileMimeType) === 'pdf'"/>
                <c-icon icon-name="doc" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'doc'"/>
                <c-icon icon-name="xlsx" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'xlsx'"/>
                <c-icon icon-name="csv" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'csv'"/>
                <c-icon icon-name="ppt" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'ppt'"/>
                <c-icon icon-name="png" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'png'"/>
                <c-icon icon-name="jpg" size="xs" class="icon" v-else-if="getFileExtension(leaveInfo.fileMimeType) === 'jpg' || getFileExtension(leaveInfo.fileMimeType) === 'jpeg'"/>
              </div>
              <div class="flex flex-col flex-grow">
                <span class="text-base text-darkPurple font-semibold">{{ leaveInfo.fileName || 'Handover File' }}</span>
                <span class="text-sm text-romanSilver">
                  <span class="text-blueCrayola">handovernote</span>
                  <span class="text-romanSilver" v-if="leaveInfo.fileSize"> • {{ formatFileSize(leaveInfo.fileSize) }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="flex justify-center p-4 gap-2 flex-grow">
            <span class="text-sm text-romanSilver">No handover note uploaded.</span>
          </div>
        </div>
      </div>
    </div>
  </RightSideBar>
</template>

<script>
import { differenceInDays } from "date-fns"
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button"
import RightSideBar from "@/components/RightSideBar"
import CIcon from "@/components/Icon";

export default {
  components: {
    BackButton,
    RightSideBar,
    CIcon
  },
  data(){
    return {
      differenceInDays,

      isOpen: false,
      isLoading: false,
      employeeInfo: {},
      leaveInfo: {},
      isHandoverNoteExpanded: false
    }
  },
  methods: {
    onOpen(leaveInfo){
      this.leaveInfo = leaveInfo
      this.employeeInfo = leaveInfo.employee
      this.isOpen = true
    },
    onSubmit(){},
    formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    getFileExtension(mimeType) {
      if (!mimeType) return '';
      const mimeToExt = {
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-excel': 'xlsx',
        'text/csv': 'csv',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
        'image/png': 'png',
        'image/jpeg': 'jpeg',
        'image/jpg': 'jpg'
      };
      return mimeToExt[mimeType] || mimeType.split('/').pop().split('.').pop();
    },
    downloadFile(fileUrl, fileName, mimeType) {
      if (!fileUrl) return;

      try {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        const downloadFileName = fileName && mimeType
          ? `${fileName}.${this.getFileExtension(mimeType)}`
          : this.getFileName(fileUrl);
        link.download = downloadFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.$toasted.error('Failed to download file', { duration: 3000 });
      }
    },
    getFileName(url) {
      if (!url) return 'uploaded file';
      const parts = url.split('/');
      const fileName = parts[parts.length - 1] || 'uploaded file';

      if (fileName.length > 30) {
        const extension = fileName.split('.').pop();
        const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
        const truncatedName = nameWithoutExt.substring(0, 30);
        return `${truncatedName}...${extension}`;
      }

      return fileName;
    }
  }
}
</script>

<style scoped>
.icon {
  width: 100% !important;
  height: 100% !important;
}
</style>